export default __webpack_public_path__ + "static/media/200.8fd0234a.woff2";